import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField, DropDownMenu, MenuItem } from 'material-ui';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Btn from '../../../components/Btn';
import '../../../grid.css';
import './ess.css';

class ESS extends Component {
    toggleESSIsVisible() {
        const { setESSIsVisible, isVisible } = this.props;
        setESSIsVisible(!isVisible);
    }

    handleESSkWChange(value) {
        const { setESSkW } = this.props;
        setESSkW(Number(value));
    }

    handleESSkWhChange(value) {
        const { setESSkWh } = this.props;
        setESSkWh(Number(value));
    }

    handleESSPriceChange(value) {
        const { setESSPrice } = this.props;
        setESSPrice(Number(value));
    }

    handleMadeInCAToggle() {
        const { setMadeInCA, madeInCA } = this.props;
        setMadeInCA(!madeInCA);
    }

    toggleIncludeESS() {
        const { setIncludeESS, includeESS } = this.props;
        setIncludeESS(!includeESS);
    }

    handleBatteryChange(value) {
        const { setBatteryType } = this.props;
        setBatteryType(value);
    }

    render() {
        const {
            esskW, essPrice, esskWh, isVisible,
            isLocked, madeInCA, includeESS, projectState, batteryType,
        } = this.props;

        return (
            <div>
                <Btn label="ESS" onClick={(e, value) => this.toggleESSIsVisible(value)} />
                {isVisible ? (
                    <div className="row">
                        <div className="col span-1-of-2 checkboxes">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={isLocked}
                                        onChange={(e, value) => this.toggleIncludeESS(value)}
                                        checked={includeESS}
                                    />
                                }
                                label="Include Storage in Simulation"
                            />
                            {includeESS ? (
                                <div>
                                    <TextField
                                        id="number"
                                        type="number"
                                        defaultValue={esskW}
                                        onChange={(e, value) => this.handleESSkWChange(value)}
                                        hintText="60"
                                        floatingLabelText="Storage kW"
                                        disabled={isLocked}
                                        fullWidth
                                    />
                                    <TextField
                                        id="number"
                                        type="number"
                                        hintText="100"
                                        defaultValue={esskWh}
                                        onChange={(e, value) => this.handleESSkWhChange(value)}
                                        floatingLabelText="Storage kWh"
                                        disabled={isLocked}
                                        fullWidth
                                    />
                                </div>
                            ) : null}
                        </div>
                        {includeESS ? (
                            <div className="col span-1-of-2">
                                <TextField
                                    id="number"
                                    fullWidth
                                    type="number"
                                    hintText="95000"
                                    defaultValue={essPrice}
                                    onChange={e => this.handleESSPriceChange(e.target.value)}
                                    floatingLabelText="ESS Price"
                                    disabled={isLocked}
                                />
                                {projectState === 1 ? (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isLocked}
                                                onChange={(e, value) =>
                                                    this.handleMadeInCAToggle(value)}
                                                checked={madeInCA}
                                            />
                                        }
                                        label="Made in CA"
                                    />
                                ) : null}
                                <DropDownMenu
                                    fullWidth
                                    floatingLabelText="Battery Type"
                                    value={batteryType}
                                    onChange={
                                        (e, index, value) => this.handleBatteryChange(value)}
                                    disabled={isLocked}
                                >
                                    <MenuItem value="fortress5" primaryText="Fortress Power 5kWh" />
                                    <MenuItem value="fortress10" primaryText="Fortress Power 10kWh" />
                                    <MenuItem value="fortress18" primaryText="Fortress Power 18kWh" />
                                    <MenuItem value="lgchem" primaryText="LG Chem" />
                                    <MenuItem value="generacbattery" primaryText="Generac PWRCell" />
                                </DropDownMenu>
                            </div>
                        ) : null }
                    </div>
                ) : null}
            </div>
        );
    }
}

ESS.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    isLocked: PropTypes.bool.isRequired,
    setESSIsVisible: PropTypes.func.isRequired,
    setESSPrice: PropTypes.func.isRequired,
    setESSkW: PropTypes.func.isRequired,
    setESSkWh: PropTypes.func.isRequired,
    esskW: PropTypes.number.isRequired,
    essPrice: PropTypes.number.isRequired,
    esskWh: PropTypes.number.isRequired,
    madeInCA: PropTypes.bool.isRequired,
    setMadeInCA: PropTypes.func.isRequired,
    includeESS: PropTypes.bool.isRequired,
    projectState: PropTypes.number.isRequired,
    setIncludeESS: PropTypes.func.isRequired,
    setBatteryType: PropTypes.func.isRequired,
    batteryType: PropTypes.string.isRequired,
};

ESS.defaultProps = {};

export default ESS;



// WEBPACK FOOTER //
// ./src/containers/Inputs/ESS/ESS.js